import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';

/**
 * Homepage class.
 */
export default class Texts extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'Splash',
    refs: ['title'],
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    gsap.registerPlugin(SplitText);

    const mySplitText = new SplitText(this.$refs.title, {
      type: 'chars',
      charsClass: 'splash__chars',
    });
    this.chars = mySplitText.chars;
    this.tl = gsap.timeline();
    this.tl.fromTo(
      this.chars,
      {
        x: '-120%',
        perspective: 100,
      },
      {
        duration: 1,
        perspective: 0,
        x: '0',
        stagger: {
          each: 0.01,
        },
        ease: 'power3.out',
        delay: 0.4,
        onStart: () => {
          this.$refs.title.classList.remove('opacity-0');
        },
      }
    );

    this.tl.fromTo(
      this.chars,
      {
        x: '0',
      },
      {
        duration: 1,
        x: '120%',
        opacity: 0,
        stagger: {
          each: 0.01,
        },
        ease: 'power3.out',
        delay: 0.4,
      },
      '+=1'
    );

    this.tl.to(this.$el, { scaleX: 0, duration: 0.5, ease: 'Power3.in.out' }, '-=0.5');
  }
}
